import dayjs from './dayjs';
import lodash from './lodash';
import helpers from './helpers';

export default app => {
  app.use(dayjs);
  app.use(lodash);
  app.use(helpers);
};
